module.exports = __webpack_public_path__ + "/build/web/svg/ic-search-black-24-px-2.74245d3602374c42f71c59807ee64474.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/ic-search-black-24-px-2.svg
// module id = 222
// module chunks = 13